import React from 'react';
import { IElement } from '@shared/models/project.model';
import { ElementPropertiesForm } from './ElementPropertiesForm';
import { useRecipeAndCustomElementProperties } from '@client/hooks/use-element-properties.hooks';

interface ElementPropertyPanelProps {
  element: IElement;
}

/**
 * This panel is only used for properties created by the user, that may be saved on a recipe.
 */
const ElementPropertyPanel: React.FC<ElementPropertyPanelProps> = ({
  element,
}) => {
  const properties = useRecipeAndCustomElementProperties(element);

  return <ElementPropertiesForm element={element} properties={properties} />;
};

export default ElementPropertyPanel;
